module.exports = __webpack_public_path__ + "images/sd-02-desktop.png";